import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import Helpers from "../../helpers/helpers";
import { getSupportDetails, resetSupportState, updateSupport } from "../../store/actions";
import MarkResolved from "./MarkResolvedModal";
import "./support.css";


const ViewInquiry = ({ inquiryDetails, editSupport, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { ID } = useParams();

    const [loading, setIsLoading] = useState(false);
    const [markResolvedOpen, setMarkResolvedOpen] = useState(false);

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editable, setEditable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("edit-support") && setEditable(true);
            !userPermission?.includes("view-support") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetSupportState());
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = () => {
        let data = {
            status: "resolved"
        }
        dispatch(updateSupport({ id: ID, support: data }))
    }

    const markAsResolvedModal = () => {
        return (
            <MarkResolved
                open={markResolvedOpen}
                close={() => setMarkResolvedOpen(false)}
                submit={() => handleSubmit()}
                selectedInquiry={inquiryDetails?.common}
            />
        )
    }

    useEffect(() => {
        if (editSupport?.code === "success") {
            setNotification({
                open: true,
                msg: "Resolved",
                type: "success",
            })
            dispatch(resetSupportState());
            setMarkResolvedOpen(false);
            initData();
        }
        setIsLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editSupport]);

    const initData = () => {
        if (ID) {
            dispatch(getSupportDetails({ id: ID }))
        }
    }


    return (
        <React.Fragment>
            <div className="page-content">
                {markAsResolvedModal()}
                <LoadingDialog open={loading || !inquiryDetails?.common} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute="/support"
                        breadcrumbItems={[{ title: "Support", link: "/support" },
                        { title: 'Inquiry Details', link: "#" },
                        ]}
                    >
                        {
                            inquiryDetails?.common?.status === 'pending' && editable &&
                            <CustomButton
                                title={'Mark as Resolved'}
                                backgroundColor={'#34C759'}
                                textColor={'white'}
                                borderStyle={'1px solid #34C759'}
                                press={() => setMarkResolvedOpen(true)}
                            />
                        }
                    </Breadcrumb>
                    <Card className="pb-3 px-1">
                        <CardBody>
                            <Grid container spacing={1} className="d-flex justify-content-between align-items-center">
                                <Grid item lg={9} xs={12} className="d-flex inquiry-header align-items-center flex-wrap">
                                    Inquiry <span style={{ color: '#7BB9FA', marginLeft: 5 }}>#{ID || "-"}</span>
                                    {inquiryDetails?.common?.status && <Label.SupportStatusLabel label={inquiryDetails?.common?.status} />}
                                    {
                                        inquiryDetails?.common?.inquiry_type &&
                                        <Label.CustomLabel
                                            label={inquiryDetails?.common?.inquiry_type ? Helpers?.convertToCustomTitleCase(inquiryDetails.common.inquiry_type) : ""}
                                            backgroundColor={'#EDEDED'}
                                            color={'#686868'}
                                            border={'1px solid #EDEDED'}
                                            marginLeft={10}
                                        />
                                    }
                                    {
                                        inquiryDetails?.common?.return_preference &&
                                        <Label.CustomLabel
                                            label={inquiryDetails?.common?.return_preference ? Helpers?.convertToCustomTitleCase(inquiryDetails.common.return_preference) : ""}
                                            color={'#282828'}
                                            border={'1px solid #282828'}
                                            marginLeft={10}
                                        />
                                    }

                                </Grid>
                                <Grid item lg={3} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', sm: 'start' } }}>
                                    <div className="inquiry-description"><span style={{ fontWeight: 600, color: "#101010" }}>Created on:</span> {inquiryDetails?.common?.created_date ? inquiryDetails.common.created_date : "-"}</div>
                                </Grid>
                            </Grid>

                            <Divider className="mt-3 mb-4" />
                            <div className="curve-container">
                                <div className="inquiry-section-header">Basic Info</div>
                                <Grid container spacing={1} marginTop={0}>
                                    <Grid container item lg={6} md={6} sm={12} xs={12} spacing={1}>
                                        <Grid item sm={3} className="inquiry-section-title">Name: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.first_name} {inquiryDetails?.common?.last_name || "-"}</Grid>
                                        <Grid item sm={3} className="inquiry-section-title">Email Address: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.email || "-"}</Grid>
                                        <Grid item sm={3} className="inquiry-section-title">Phone number: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.phone || "-"}</Grid>
                                    </Grid>
                                    <Grid container item lg={6} md={6} sm={12} xs={12} spacing={1}>
                                        <Grid item sm={3} className="inquiry-section-title">Create Date: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.created_date ? inquiryDetails.common.created_date : "-"}</Grid>
                                        <Grid item sm={3} className="inquiry-section-title">Resolved Date: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.resolved_date ? inquiryDetails.common.resolved_date : "-"}</Grid>
                                        <Grid item sm={3} className="inquiry-section-title">Resolved by: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.resolved_by || "-"}</Grid>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className="curve-container mt-4">
                                <div className="inquiry-section-header">Order (if applicable)</div>
                                <Grid container spacing={1} marginTop={0}>
                                    <Grid container item lg={6} md={6} sm={12} xs={12} spacing={1}>
                                        <Grid item sm={3} className="inquiry-section-title">Order ID: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.order_id && inquiryDetails.common.order_id !== '-' ? <Link className="clickable-text" to={`/view-order/aspeed/${inquiryDetails.common.order_id}`}>#{inquiryDetails.common.order_id}</Link> : "-"}</Grid>
                                        {
                                            inquiryDetails?.common?.order_amount &&
                                            <>
                                                <Grid item sm={3} className="inquiry-section-title">Order amount </Grid>
                                                <Grid item sm={9}>{inquiryDetails?.common?.order_amount ? "S$" + inquiryDetails.common.order_amount : "-"}</Grid>
                                            </>
                                        }
                                    </Grid>
                                    {/* <Grid container item lg={6} md={6} sm={12} xs={12} spacing={1}>
                                        <Grid item sm={3} className="inquiry-section-title">Order date: </Grid>
                                        <Grid item sm={9}>{inquiryDetails?.common?.order_date ? inquiryDetails.common.order_date : "-"}</Grid>
                                    </Grid> */}
                                </Grid>
                            </div>
                            <div className="curve-container mt-4">
                                <div className="inquiry-section-header">Inquiry Details</div>
                                <Grid container spacing={1} marginTop={0}>
                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Inquiry type </Grid>
                                    <Grid item sm={9} xs={12} className="text-bold">{inquiryDetails?.common?.inquiry_type ? inquiryDetails.common.inquiry_type : "-"}</Grid>
                                    {
                                        inquiryDetails?.common?.return_preference && inquiryDetails?.common?.return_preference !== '-' &&
                                        <>
                                            <Grid item sm={3} xs={12} className="inquiry-section-title">Return preference </Grid>
                                            <Grid item sm={9} xs={12} className="text-bold">{inquiryDetails?.common?.return_preference ? inquiryDetails.common.return_preference : "-"}</Grid>
                                        </>
                                    }
                                    {
                                        inquiryDetails?.common?.payment_method && inquiryDetails?.common?.payment_method !== '-' &&
                                        <>
                                            <Grid item sm={3} xs={12} className="inquiry-section-title">Payment method</Grid>
                                            <Grid item sm={9} xs={12}>{inquiryDetails?.common?.payment_method || "-"}</Grid>
                                        </>
                                    }
                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Additional details</Grid>
                                    <Grid item sm={9} xs={12}>{inquiryDetails?.common?.message || "-"}</Grid>
                                </Grid>
                            </div>
                            {
                                inquiryDetails?.contacts?.length > 0 &&
                                <div className="curve-container mt-4">
                                    <div className="inquiry-section-header">Product Information ({inquiryDetails?.contacts?.length || 0} selected)</div>
                                    {
                                        inquiryDetails.contacts.map((item) => {
                                            return (
                                                <Grid container spacing={2} marginTop={0}>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Product details </Grid>
                                                    <Grid item sm={9} xs={12}>
                                                        <Grid item md={1.2} sm={2} className="d-flex">
                                                            <img src={item?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 56, width: '80%', objectFit: "contain" }} />
                                                        </Grid>
                                                        <Grid item md={10.8} sm={10}>
                                                            <div className="d-flex text-semibold align-items-center">
                                                                {/* <Label.FreeGiftLabel /> if it is free gift */}
                                                                {item?.product_name || '-'}
                                                            </div>
                                                            <div className="subheader-2 font-size-12 mt-1">SKU: {item?.product_sku || '-'}</div>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Refund quantity</Grid>
                                                    <Grid item sm={9} xs={12}>{item?.quantity || "-"}</Grid>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Purchase price</Grid>
                                                    <Grid item sm={9} xs={12}>{item?.purchase_price || "-"}</Grid>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Reason for return </Grid>
                                                    <Grid item sm={9} xs={12}>
                                                        <div className="text-bold">{item?.reason_for_return || "-"}</div>
                                                    </Grid>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Condition of the product </Grid>
                                                    <Grid item sm={9} xs={12}>
                                                        {
                                                            item?.product_condition?.length > 0 ?
                                                                <ol className="p-0 px-3">
                                                                    {
                                                                        item?.product_condition.map((condition, idx) => {
                                                                            return (
                                                                                <li className="text-bold">{condition || "-"}</li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ol> : "-"
                                                        }
                                                        <div className="text-Semibold">{item?.other_product_condition || ''}</div>
                                                    </Grid>
                                                    <Grid item sm={3} xs={12} className="inquiry-section-title">Attachment</Grid>
                                                    <Grid item sm={9} xs={12}>
                                                        {
                                                            item?.attachments?.length > 0 ? item?.attachments?.map((x, idx) =>
                                                                <img key={idx} src={x?.url} alt="product-image" style={{ height: 96, width: 120, objectFit: "contain", marginRight: 10 }} />
                                                            ) : "-"
                                                        }
                                                    </Grid>
                                                    <Grid item sm={12} className="mt-1 mb-3"><Divider /></Grid>
                                                </Grid>
                                            )
                                        })
                                    }
                                </div>
                            }

                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Support, Login }) {

    return {
        inquiryDetails: Support.supportDetails,
        editSupport: Support.editSupport,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(ViewInquiry);